import { createSlice } from '@reduxjs/toolkit';
import { UpcomingPayments } from 'src/@types/upcoming-payments';

type FundingRemittanceSchedule = {
  amountExpected: string;
  fundingId: string;
  paymentScheduleDate: string;
};

type PaymentHistory = {
  fundedDeal: string;
  fundedAmount: number;
  paybackAmount: number;
  transactionType: string;
  paymentDate: Date;
  paymentAmount: number;
  returnAmount: number;
  isCredit: boolean;
};

export type FundingRemittanceScheduleState = {
  fundingRemittanceSchedules: FundingRemittanceSchedule[];
  paymentsHistory: PaymentHistory[];
  upcomingPayments: UpcomingPayments[];
};

export const initialState: FundingRemittanceScheduleState = {
  fundingRemittanceSchedules: [] as FundingRemittanceSchedule[],
  paymentsHistory: [] as PaymentHistory[],
  upcomingPayments: [] as UpcomingPayments[],
};

const slice = createSlice({
  name: 'fundingRemittanceSchedule',
  initialState,
  reducers: {
    setFundingRemittanceSchedules(state, action) {
      state.fundingRemittanceSchedules = action.payload;
    },
    setPaymentsHistory(state, action) {
      state.paymentsHistory = action.payload;
    },
    setUpcomingPayments(state, action) {
      state.upcomingPayments = action.payload;
    },
  },
});
export default slice.reducer;

export const { setFundingRemittanceSchedules, setPaymentsHistory, setUpcomingPayments } =
  slice.actions;
